import React, { useCallback } from 'react';
import Dropzone from 'react-dropzone';

import Label from '../Label/Label';

import Description from '../Description/Description';

import styles from './ImageUpload.module.css';
import { httpPost } from '../../../../utils';
import {
    ALLOWED_IMG_CONTENT_TYPES_TO_IMPORT,
    ALLOWED_IMG_EXTENTIONS_TO_IMPORT,
    MAX_FILE_NAME_LENGTH_TO_IMPORT
} from '@silverfort-nodelibs/common/utils/consts';

const ImageUpload = ({ field, changed, allowRemove = false }) => {
    const upload = useCallback(
        (files) => {
            if (!files || files.length === 0) {
                return;
            }

            const file = files[0];
            if (file.size > 150000) {
                // TODO: show error
                return console.error('File size exceed 150KB');
            }

            if (file.name.length > MAX_FILE_NAME_LENGTH_TO_IMPORT) {
                console.error(`File name should be up to ${MAX_FILE_NAME_LENGTH_TO_IMPORT} characters`);
                return;
            }

            const file_extension = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();

            if (
                !ALLOWED_IMG_EXTENTIONS_TO_IMPORT.includes(file_extension) ||
                !ALLOWED_IMG_CONTENT_TYPES_TO_IMPORT.includes(file.type)
            ) {
                console.error(`Invalid image type`);
                return;
            }

            const fileData = new FormData();
            fileData.append('file', file);

            const reader = new FileReader();
            reader.onload = async () => {
                try {
                    const { data } = await httpPost(`/Settings/UploadImage`, fileData);
                    changed(field.id, { fileName: data.newFileName, fileValue: reader.result });
                } catch (err) {
                    // TODO: show error
                    console.error('File upload failed', err);
                }
            };
            reader.readAsDataURL(file);
        },
        [field, changed]
    );

    const removeImage = () => {
        changed(field.id, '');
    };

    const imageSrc = field.value && field.value.fileValue ? field.value.fileValue : `/${field.value}`;
    return (
        <div className={styles.container}>
            <Label value={field.name} />
            <div className={styles.imageContainer}>
                <Dropzone
                    id="companyLogo"
                    className={styles.dropZone}
                    onDrop={upload}
                    multiple={false}
                    maxSize={150000}
                    accept={'image/png'}
                    activeClassName={styles.accept}
                    rejectClassName={styles.reject}>
                    {({ isDragReject }) => {
                        let message = (
                            <span className={styles.dropZoneLabel}>
                                <span className={styles.uploadText}>Upload</span> or drag an image<br></br>(PNG, max.
                                file Size: 150KB)
                            </span>
                        );
                        if (isDragReject) {
                            message = <span className={styles.reject}>File type not allowed</span>;
                        }

                        return (
                            <>
                                <img className={styles.image} src={imageSrc} alt="" />
                                {message}
                            </>
                        );
                    }}
                </Dropzone>
                <div className={styles.removeContainer}>
                    {imageSrc && allowRemove && (
                        <span className={styles.remove} onClick={removeImage}>
                            x
                        </span>
                    )}
                </div>
            </div>
            {field.desc && <Description value={field.desc} />}
        </div>
    );
};

export default React.memo(ImageUpload);
